export default {
    // 接口url
    queryQuestionBase:"app/accRiskQuestionBase/queryQuestionBase", // 查询答卷内容
    calAnswerScore:"app/accRiskQuestionBase/calAnswerScore", // 计算分数
    sendQestionResult:"app/accRiskQuestionBase/sendQestionResult", // 发送邮箱
    privateDetail:"pms/product/private/detail", //私募详情
    privateEarningChart: "pms/earnings/trends", //私募货基七日年化走势
    performanceTrendPri:"pms/product/private/performanceTrend" ,//业绩走势
    unitEquityTrendPri:"pms/product/private/unitEquityTrend" ,//单位净值
    cumulativeNetWorthTrendPri:"pms/product/private/cumulativeNetWorthTrend" ,//累计净值
    historyList:"pms/product/private/history_net_value/list", //历史净值加载更多
    historicalNetWorthPrivate:"pms/product/private/historicalNetWorth", //历史净值
    verification:"pms/product/private/verification", //鉴权
    updateByCompanyAppAdmit:"pms/product/private/updateByCompanyAppAdmit", //修改自认状态
    switchableSubProductList:"pms/product/private/switchableSubProductList", //私募开放日列表
    saveInvestorIdentificationA:"cms/InvestorCreitApply/saveInvestorApplicationDraft", //保存草稿合格投资者认定
    investorIdentificationA:"cms/InvestorCreitApply/investorIdentificationA", //提交合格投资者认定
    fileUpload:"oss/fileUpload", //生成文件Id
    checkWhetherProfession:"cms/InvestorCreitApply/checkWhetherProfession", //校验职业类型
    getLocation:'cms/countryLoadLocationList',//获取国家
    getLocationList:'cms/loadLocationList',//获取省份
    getLoadCity:'cms/loadCityList',//获取市
    getLoadArea:'cms/loadAreaList',//获取区
    getType:'cms/cmsGroupAccount/getLocationList', 
    BankAccountManagements:'cms/cmsBank/BankAccountManagements',//获取银行卡信息
    BankAccountWithholding:'cms/cmsBank/BankAccountWithholding',//支持银行卡
    InvestorCreitApplyStatus:'cms/InvestorCreitApply/status',//获取投资者状态
    InvestorOrgStatus:'cms/InvestorCreitApply/orgStatus',//机构获取投资者状态
    getQuestionList:'cms/adequacyManagement/getQuestionList',
    getResultStatus:'cms/adequacyManagement/getResults',
    getQuestionRestult:'cms/adequacyManagement/evaluating',
    submitAccount:'cms/cmsGroupAccount/individualAccount',
    saveAccount:'cms/cmsGroupAccount/saveMainBodyDraft', //非实名保存个人相关信息
    realSubmit:'cms/cmsGroupAccount/add',
    realSave:'cms/cmsGroupAccount/saveGroupInformation',
    getRealDraft:'cms/cmsGroupAccount/groupDraftInformationEcho',//获取非身份证实名信息草稿
    getRelevantDraft:'cms/cmsGroupAccount/personMainBodyDraftEcho',//获取非身份证相关信息草稿
    bindBankCard:'cms/cmsBank/bindBankCard', //新增银行账户
    getTypeOfCertificates:'cms/cmsGroupAccount/typeOfCertificates',//证件类型
    getAccountInfo:'cms/cmsGroupAccount/personalInformationById',
    getSpecificNatural:'cms/cmsGroupAccount/specificNaturalPerson',
    modifyAccount:'cms/cmsGroupAccount/modifyOccupation',
    modifyInformationById:'cms/cmsGroupAccount/modifyInformationById', //补录涉税信息
    getOrgDetail:'pms/product/private/investmentAgencyDetails', //投资机构详情
    operatingBypmsOptional:'pms/product/private/operatingBypmsOptional', 
    setPubBankCard:'personalCenter/setToPubBankCard',//设置公募卡--个人身份证
    setPubBankCardNonIdCard:'personalCenter/setToPubBankCardOfNonIdCard',//设置公募卡--个人非身份证
    findBankCard:'personalCenter/findBankCardManagement', //shlx——查询用户银行卡列表--个人身份证
    findNoIdBankCard:'personalCenter/findBankCardManagementOfNonIdCard', //shlx——查询用户银行卡列表--个人非身份证
    findAutoDeductionBankCard:'personalCenter/findAutoDeductionBankList', //查询支持自动扣款的银行列表--个人
    findBankCardDetail:'personalCenter/findBankCardDetail', //查询银行卡详情--个人
    findCardDetail:'personalCenter/findBankCardDetailOfFinal', //查询银行卡详情--交易跳转而来
    meiShiCheckBankCard:'personalCenter/checkCard',//添加银行卡时的验卡--个人
    addBankCard:'personalCenter/addBankCard', //添加银行卡--个人
    findOptionalBankList:"personalCenter/findOptionalBankList",//查询开户银行列表--个人
    getContactInfo:'personalCenter/findContactInfo',//获取联系信息--个人
    saveRealNameInfo:'personalCenter/saveRealNameInfo', //保存实名信息--个人
    getAccount:'personalCenter/findAccountInfo', //查询账户信息--个人
    saveEmail:'personalCenter/saveEmail',//保存邮箱--个人
    updateAppAdmit:'cms/InvestorCreitApply/updateByCompanyAppAdmit',//投资者自认
    automaticVerification:'cms/InvestorCreitApply/automaticVerification',//校验客户可否自动认定
    automaticConfirm:'cms/InvestorCreitApply/automaticConfirm',//客户确认自动认定
    saveAddress:'personalCenter/saveAddress',//保存地址--个人
    findCountryList:'personalCenter/findCountryList',//查询国家--个人
    findProvinceOrCity:'personalCenter/findProvinceOrCity',//查询省/市/县、区--个人
    accountSubjectCopy:'cms/cmsGroupAccount/accountSubjectCopy', //开户主体选择
    getTheSubjectById:"cms/cmsGroupAccount/getTheSubjectById",//返回个人主键ID
    bindWealthAdvivisor:"personalCenter/saveFaInfo", //绑定财富顾问--个人
    personalTaxRelatedById:"cms/cmsGroupAccount/personalTaxRelatedById", //获取税收信息
    checkAlreadyFa:"cms/cmsGroupAccount/checkAlreadyFa", //获取手机号是否有fa
    getOrgBankList:"orgPersonalCenter/findBankCardManagement", //查询银行卡管理页--机构
    setOrgPubCard:"orgPersonalCenter/setToPubCard",//设置公募卡--机构
    findOpenAccountBankList:"orgPersonalCenter/findOpenAccountBankList",//查询开户银行列表--机构
    findOpenAccountProvinceOrCity:"orgPersonalCenter/findOpenAccountProvinceOrCity",//开户省市--机构
    addOrgBankCard:"orgPersonalCenter/submitOfAddBankCard",//添加银行卡--机构
    checkPubCardCode:"personalCenter/checkVerCodeOfSetToPubCard",//身份证个人——设为公募卡，校验短信验证码
    getOrgAccountInfo:"orgPersonalCenter/findOrgAccountOutLineInfo",//账户信息--机构
    findOrgControlHolderInfo:"orgPersonalCenter/findOrgControlHolderInfo",//控股股东--机构
    findOrgContactInfo:"orgPersonalCenter/findOrgContactInfo",//联系信息--机构
    findOrgBeneficiaryInfo:"orgPersonalCenter/findOrgBeneficiaryInfo",//受益人--机构
    findOrgAuthAgentInfo:"orgPersonalCenter/findOrgAuthAgentInfo",//经办人--机构
    findOrgTaxStatement:"orgPersonalCenter/findOrgTaxStatement",//税收声明--机构
    getCountryList:"orgPersonalCenter/findCountryList",//国籍--机构
    getCardBin: "personalCenter/findBankByCardBin",//卡bin
    enumerateOrg: "cms/OrgOpen/enumerateOrg", //机构字典
    provinceCityDistrictList: "cms/provinceCityDistrictList", //省市区三级联动
    countryLoadLocationList: "cms/countryLoadLocationList", // 国家
    orgAdd: "cms/OrgOpen/orgAdd", // 新增机构主体
    modifyGroupLegalPerson: "cms/OrgOpen/modifyGroupLegalPerson", // 新增法人
    insertBeneficiary: "cms/OrgOpen/insertBeneficiary", // 新增受益人
    modifyAuthorizedManager: "cms/OrgOpen/modifyAuthorizedManager", // 授权经办人
    insertActualController: "cms/OrgOpen/insertActualController", // 实控人
    insertInstitutionalTaxation: "cms/OrgOpen/insertInstitutionalTaxation", // 税收
    orgBaseInfo: "orgPersonalCenter/findOrgBaseInfo", // 基本信息--机构
    investorIdentificationOrg: "cms/InvestorCreitApply/investorIdentificationApplicationOrg", // 机构投资者上传
    findBranchBankList: "personalCenter/findBranchBankList", // 支行
    submitOrgBaseInfo: "orgPersonalCenter/submitOrgBaseInfo", // 修改提交基本信息--机构
    verificationReferrer: "cms/OrgOpen/verificationReferrer", // 法定代表人fa
    evaluatingOrg: "cms/adequacyManagement/evaluatingOrg", // 机构风测
    findDictListByParentDictCode: "orgPersonalCenter/findDictListByParentDictCode", // 根据父级字典dict_code，查询字典键值对集合
    findRiskAssessmentInfo: "orgPersonalCenter/findRiskAssessmentInfo", // 机构风测及结果
    afreshRiskAssessment: "orgPersonalCenter/afreshRiskAssessment", // 机构提交及重新测评
    convertPinyin: "cms/cmsGroupAccount/convertPinyin", // 中文转拼音
    checkCRS: "cms/cmsGroupAccount/crsDataValida", // 税收国家校验
    addAssetsProof: "cms/assetsProof/addAssetsProof",//提交资产证明申请
    assetsProofProduct: "cms/assetsProof/assetsProofProduct",//获取资产产品列表

    //注册流程
    checkAlreadyImage: "cms/cmsGroupAccount/checkAlreadyImage", //根据集团公共表id查询用户是否已上传影像件
    checkImageUnanimou: "cms/cmsGroupAccount/checkImageUnanimous", //校验用户上传影像件与需上传的是否一致
    terminationFixedInvestment:"cms/adequacyManagement/terminationFixedInvestment",//根据客户风测等级和定投产品风险等级对比
    // 私募存续
    totalAssets: 'pms/pri/assetsSurvival/totalAssets', //总资产
    totalAssetsNew:'pms/pri/assetsSurvival/totalAssetsNew',
    priHistoryInves: 'pms/pri/assetsSurvival/historicalInvestment', //历史投资
    allAssetsList: 'pms/pri/assetsSurvival/allAssets', //tab全部资产
    remaining: 'pms/pri/assetsSurvival/detail', //存续详情
    productReport: 'pms/pri/assetsSurvival/productReport', //产品报告
    myLetter: 'pms/pri/assetsSurvival/myLetter', //产品报告/公告基金名称
    productAnnouncement: 'pms/pri/assetsSurvival/productAnnouncement', //产品公告
    historicalNetWorth: 'pms/pri/assetsSurvival/historicalNetWorth', //历史净值
    transactionDetails: 'pms/pri/assetsSurvival/transactionDetails', //交易明细
    investmentReview: 'pms/pri/assetsSurvival/investmentReview', //投资检视
    orderDetails: 'pms/pri/assetsSurvival/orderDetails', //投资检视详情
    performanceTrend: 'pms/pri/assetsSurvival/performanceTrend', //存续业绩走势
    unitEquityTrend: 'pms/pri/assetsSurvival/unitEquityTrend', //存续单位净值走势
    cumulativeNetWorthTrend: 'pms/pri/assetsSurvival/cumulativeNetWorthTrend', //存续累计净值走势
    relatedDocuments: 'pms/pri/assetsSurvival/relatedDocuments', //相关文件
    sendFilesToCustomerEmail: 'pms/pri/assetsSurvival/sendFilesToCustomerEmail',
    isWhitelistPrivate: 'pms/pri/assetsSurvival/isWhitelist',
    isSpecial:"private/product/special",//是否特殊产品  PJ202
    privateHistoryAssets:"pms/new/assets/privateHistoryAssets", //私募清仓产品
    //公募存续
    publicSurvival: 'pms/pub/assetsSurvival/publicSurvival', //资产
    publicSurvivalNew: "pms/pub/assetsSurvival/publicSurvivalNew",//总资产-新
    holdingAssets: 'pms/pub/assetsSurvival/holdingAssets', //持有资产
    pubRemaining: 'pms/pub/assetsSurvival/detail', //存续详情
    pubHistoryInves: 'pms/pub/assetsSurvival/historicalInvestment', //历史投资
    pubEarningsTrend: 'pms/pub/assetsSurvival/earningsTrend', //收益走势
    pubPerformanceTrend: 'pms/pub/assetsSurvival/performanceTrend', //业绩走势
    pubNetWorthTrendEstimation: 'pms/pub/assetsSurvival/netWorthTrendEstimation', //净值走势估算
    estimation: 'pms/pub/assetsSurvival/open/estimation', //保存净值估算遮罩点击记录
    getOpenEstimationStatus: 'pms/pub/assetsSurvival/isOpen/estimation', //查询用户是否已开启遮罩,已开启返回true
    investmentReviewPub: 'pms/pub/assetsSurvival/investmentReview', //投资检视
    orderDetailsPub: 'pms/pub/assetsSurvival/orderDetails', //投资检视详情
    newFundDetails: "pms/product/pub/newFundDetails", //新品首发获取数据
    addSalesReminder : "pms/product/pub/addSalesReminder ", //新品首发-- 添加开售提醒
    removeSalesReminder: "pms/product/pub/removeSalesReminder", //新品首发-- 取消开售提醒
    annualizedTrend: "pms/pub/assetsSurvival/annualizedTrend", //七日年化走势
    incomeTrend: "pms/pub/assetsSurvival/incomeTrend", //累计收益
    publicHistoryAssets:"pms/new/assets/publicHistoryAssets", //公募清仓
    //私募列表
    privateCategories: "pms/product/categories", //私募列表产品大类
    privateList: "pms/product/private/list", //私募列表
    getTopBar:"private/product/index/getTopBar", //私募列表产品大类(含二级分类)
    getNewList:"private/product/index/getNewList", //私募列表产品列表数据
    getPreviewList:"private/product/index/getPreviewList", //私募列表预览产品列表数据

    // 私募金刚区
    getMenuBar: "private/product/index/getMenuBar",
    // 私募产品主页分类列表
    getCardList: "private/product/index/getCardList",

    //确认补录
    findConfirmInfo: 'infoConfirmAndSupply/findConfirmInfo', //老客户信息确认&补录
    infoConfirm: 'infoConfirmAndSupply/infoConfirm', //客户点击确认按钮
    infoSupply: 'infoConfirmAndSupply/infoSupply', //信息补录
    orgFindConfirmInfo: 'orgInfoConfirmAndSupply/findConfirmInfo', //机构确认信息查询
    orgInfoConfirm: 'orgInfoConfirmAndSupply/infoConfirm', //机构客户点击确认按钮
    taxEcho: 'infoConfirmAndSupply/findTaxInfoEchoOnSupply', //补录：税收信息回显

    //个人信息更改
    sendVerificationCode: 'infoUpdate/sendVerificationCode', //发送邮箱验证码
    verifyCode: 'infoUpdate/verify', //验证邮箱验证码
    getExpireTime: 'infoUpdate/expireTime', //获取邮箱发送后的一分钟倒计时剩余时间

    //app信息修改
    sendPhoneCode: 'infoUpdate/sendMobileVerificationCode', //手机号-获取验证码
    updateMobile: 'infoUpdate/updateMobile', //手机号-验证验证码
    updateMobileEvidence: 'infoUpdate/updateMobileEvidence', //手机号-验证上传相关证明材料

    // 高龄接口
    recognitionOfOldAgeVerification:'cms/InvestorCreitApply/recognitionOfOldAgeVerification', //获取高龄状态
    agreedBuryingPointOld:'cms/InvestorCreitApply/agreedBuryingPointOld', //同意自动认定接口埋点
    automaticIdentificationOld:'cms/InvestorCreitApply/automaticIdentificationOld',//确认自动认定
    materialIdentificationOld:'cms/InvestorCreitApply/materialIdentificationOld', //材料认定上传接口

    //推介材料接口
    getPromotionalMaterials:'pms/product/private/getPromotionalMaterials', //获取推介材料详情
    sendPromotionalMaterialsEmail:'pms/product/private/sendPromotionalMaterialsEmail', //发送邮箱

    //信息更改
    updateVocationId: 'infoUpdate/vocationId', //修改职业类型
    updateIncome: 'infoUpdate/annualIncome', //修改年收入
    checkIncome: 'infoUpdate/annualIncomeCheck', //修改年收入校验
    updateAddress: 'infoUpdate/address', //修改省市区 邮编
    updateNatural: 'infoUpdate/specifyNatural', //修改是否特定自然人
    updateRecord: 'infoUpdate/negativeCredibilityRecord', //修改是否有不良诚信记录


    //app信息修改
    updateCertValidDate: 'infoUpdate/certValidDate', //修改证件有效期
    // 后台埋点记录
    H5LogDetail:"user/option/log",
    //反洗钱校验
    amlBlacklistVerification:"cms/cmsGroupAccount/amlBlacklistVerification",
    // 获取个人中心信息
    // getPersonalCenterInfo:"personalCenter/homePage",
    editBankCardInfo:"personalCenter/editBankCardInfo",//银行卡修改
    editOrgBaseInfo:"personalCenter/editOrgBaseInfo",//机构信息修改
    findAgentInfo:"personalCenter/findAgentInfo",//经办人查询
    editAgentInfo:"personalCenter/editAgentInfo",//经办人修改
    getTheSubjectByIdOrg:"cms/cmsGroupAccount/getTheSubjectByIdOrg",//返回机构主键ID
    orgStatus:'cms/InvestorCreitApply/orgStatus',//机构-获取投资者状态
    updateAppAdmitOrg:'cms/InvestorCreitApply/updateByCompanyAppAdmitOrg',//机构--投资者自认
    investorIdentificationApplicationOrg:"cms/InvestorCreitApply/investorIdentificationApplicationOrg", // 机构--提交合格投资者认定

    findAllProvince:"personalCenter/findAllProvince", //银行卡 省list查询
    findAllCity:"personalCenter/findAllCity", //银行卡 市list查询

    // 获取个人中心信息
    getPersonalCenterInfo:"personalCenter/homePage",

    // 修改提交税收身份声明-个人
    modifyTaxRelatedPerson:"cms/cmsTaxTelated/modifyTaxRelatedPerson",
    // 获取税收身份声明-机构
    orgTaxRelatedEcho:"cms/cmsTaxTelated/orgTaxRelatedEcho",
    // 修改税收身份声明-机构
    modifyTaxRelatedOrg:"cms/cmsTaxTelated/modifyTaxRelatedOrg",
    //修改办公邮箱
    editEmialForOrg:"personalCenter/editEmail",
    //请求开通平安付
    openPingAnFu:"personalCenter/openPingAnFu",
    //发送平安付验证码
    sendPingAnFuSmsCode:"personalCenter/sendPingAnFuSmsCode",
    //验证平安付验证码
    verifyPingAnFuSmsCode:"personalCenter/verifyPingAnFuSmsCode",
    //设置公募卡
    setPublicBankAccount:"personalCenter/setPublicBankAccount",
     //设置公募分红方式
    setPubDividendMode:"pms/pub/assetsSurvival/submit/dividendMode",
     //设置私募分红方式
    setPriDividendMode:"pms/pri/assetsSurvival/submit/dividendMode",
    //销户前置判断
    judgeCancelStatus:"personalCenter/judgeCancelStatus",
    //获取OCR信息
    addOcrInfo:'cms/cmsGroupAccount/addOcrInfo',  

    //资产首页
    assetHome: 'pms/new/assets/index',
    //资产首页额外参数接口,如电话，消息待办数量等
    assetsExtra: 'pms/new/assets/extra',
    //校验订阅私募交易凭证是否显示
    subscribeStatusAndCc: 'personalCenter/get/subscribeStatusAndCc',
    //订阅私募交易凭证开启/关闭
    priTradeVoucherSubscribeStatus:'personalCenter/switch/priTradeVoucher/subscribe/status',
    //订阅私募交易凭证邮箱添加
    operatEmailCc: 'personalCenter/operate/email/cc',
    //交易凭证补发发送邮件
    priTradeVoucherSend: 'personalCenter/reissue/priTradeVoucher/send',

    //投资经历自动认定
    validAutoApproved: 'cms/InvestorCreitApply/validAutoApproved',

    //招行签约结果查询
    cmbSignResult: 'personalCenter/zhSignResult',
    //增加心跳检测接口
    heartbeat:'preCheck/assets',
    //获取客户邮箱
    analysisGetCustomerEmail: 'pri/investment/analysis/getCustomerEmail',
    //是否展示资产分析报告按钮
    investmentReportShow: 'pri/investment/analysis/investment/report/show',
    //发送资产分析报告邮件
    sendPriInvestmentReport: 'pri/investment/analysis/sendPriInvestmentReport'
}
